import React, { ReactNode } from 'react';
import Link from 'next/link';
import cl from 'classnames';

import { GADataType, IsDisabled } from '../../../types';

type NextLinkHelperOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => void;

interface NextLinkHelperProps {
  id?: string;
  className?: string;
  href: string;
  target?: '_blank';
  prefetch?: boolean;
  title?: string;
  onClick?: NextLinkHelperOnClick;
  onMouseEnter?: () => void;
  children: ReactNode;
  as?: string;
  disabled?: IsDisabled;
}

function NextLinkHelper({
  as,
  children,
  className,
  dataGa,
  href,
  id,
  onClick,
  onMouseEnter,
  prefetch,
  target,
  title,
  disabled
}: NextLinkHelperProps & GADataType) {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
    } else {
      onClick?.(e);
    }
  };

  return (
    <Link
      as={as}
      className={cl(className, { 'pointer-events-none': disabled })}
      data-ga={dataGa}
      href={href}
      id={id}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      prefetch={prefetch}
      target={target}
      title={title}
      tabIndex={disabled ? -1 : undefined}
    >
      {children}
    </Link>
  );
}

export default NextLinkHelper;
